import React from 'react';
import { useLocation } from 'react-router-dom';

export function sleep(ms: number = 0): Promise<void> {
  return new Promise((r) => {
    setTimeout(r, ms);
  });
}

export function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function getRandom(min: number = 0, max: number = 1000000) {
  return new Date().getTime() + Math.round(Math.random() * (max - min) + min);
}
